export default "/_next/static/images/2022-1x-435ba0e03ac3e4696b3c73d76fbbe23b.png";